
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11.594","cy":"20","r":"5.5","stroke":"#fff"}}),_c('path',{attrs:{"d":"M8.377 18.955h1.73a1 1 0 00.952-.691l.535-1.646.535 1.646a1 1 0 00.95.69h1.731l-1.4 1.018a1 1 0 00-.363 1.118l.535 1.646-1.4-1.017a1 1 0 00-1.176 0l-1.4 1.017.535-1.646a1 1 0 00-.364-1.118l-1.4-1.017zm0 0v-.5.5l-.294.404.294-.404z","stroke":"#fff","stroke-linejoin":"round"}}),_c('rect',{attrs:{"x":".094","y":"3.536","width":"5","height":"16","rx":"2","transform":"rotate(-45 .094 3.536)","stroke":"#fff"}}),_c('rect',{attrs:{"width":"5","height":"16","rx":"2","transform":"scale(-1 1) rotate(-45 -7.204 29.463)","stroke":"#fff"}})])
          )
        }
      }
    